import { render, staticRenderFns } from "./ModalFormNewTypeService.vue?vue&type=template&id=82c43068"
import script from "./ModalFormNewTypeService.vue?vue&type=script&lang=js"
export * from "./ModalFormNewTypeService.vue?vue&type=script&lang=js"
import style0 from "./ModalFormNewTypeService.vue?vue&type=style&index=0&id=82c43068&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82c43068')) {
      api.createRecord('82c43068', component.options)
    } else {
      api.reload('82c43068', component.options)
    }
    module.hot.accept("./ModalFormNewTypeService.vue?vue&type=template&id=82c43068", function () {
      api.rerender('82c43068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalFormNewTypeService.vue"
export default component.exports